import { useContext, useEffect, useRef } from 'react';

import { useDynatrace } from '@src/hooks/use-dynatrace.hook';
import { AnalyticsUserContext } from '@src/contexts/analytics-user-context';

export const useInitDynatraceRum = () => {
  const { loaded: analyticsUserContextLoaded, analyticsUserContextResponse } =
    useContext(AnalyticsUserContext);
  const initializedRef = useRef(false);
  const { identifyUser } = useDynatrace();

  useEffect(() => {
    if (
      analyticsUserContextLoaded &&
      analyticsUserContextResponse?.userContextData?.userId &&
      !initializedRef.current
    ) {
      identifyUser(`${analyticsUserContextResponse.userContextData.userId}`);
      initializedRef.current = true;
    }
  }, [analyticsUserContextResponse, analyticsUserContextLoaded, identifyUser]);
};
